// src/services/discountService.js - GÜNCELLENMIŞ VERSİYON
import {
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
  query,
  where,
  orderBy,
  serverTimestamp,
  writeBatch,
  addDoc,
  deleteDoc
} from 'firebase/firestore';
import { db } from '../firebase';

// ==================== KOLEKSİYONLAR ====================
const campaignsCollection = collection(db, 'Campaigns');
const productsCollection = collection(db, 'Products');

// ==================== ESKİ İNDİRİM YÖNETİMİ (KORUNDI) ====================

/**
 * Ürüne indirim uygula (ESKİ - Geriye dönük uyumluluk için)
 */
export const applyProductDiscount = async (productId, discountData) => {
  try {
    const productRef = doc(db, 'Products', productId);
    const snapshot = await getDoc(productRef);

    if (!snapshot.exists()) {
      return { success: false, error: 'Ürün bulunamadı' };
    }

    const product = snapshot.data();
    const originalPrice = product.originalPrice || product.price;
    let newPrice = originalPrice;

    switch (discountData.type) {
      case 'percentage':
        newPrice = originalPrice * (1 - discountData.value / 100);
        break;
      case 'fixed':
        newPrice = originalPrice - discountData.value;
        break;
      default:
        newPrice = originalPrice;
    }

    newPrice = Math.max(0, newPrice);

    await updateDoc(productRef, {
      originalPrice: originalPrice,
      currentPrice: newPrice,
      price: newPrice,
      discountType: discountData.type,
      discountValue: discountData.value,
      discountStartDate: discountData.startDate || null,
      discountEndDate: discountData.endDate || null,
      discount: discountData.type === 'percentage' ? discountData.value :
        Math.round((1 - newPrice / originalPrice) * 100),
      updatedAt: serverTimestamp()
    });

    return { success: true, newPrice, originalPrice };
  } catch (error) {
    console.error('applyProductDiscount error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Üründen indirimi kaldır
 */
export const removeProductDiscount = async (productId) => {
  try {
    const productRef = doc(db, 'Products', productId);
    const snapshot = await getDoc(productRef);

    if (!snapshot.exists()) {
      return { success: false, error: 'Ürün bulunamadı' };
    }

    const product = snapshot.data();
    const originalPrice = product.originalPrice || product.price;

    await updateDoc(productRef, {
      currentPrice: originalPrice,
      price: originalPrice,
      discountType: 'none',
      discountValue: 0,
      discount: 0,
      discountStartDate: null,
      discountEndDate: null,
      campaignId: null,
      campaignTitle: null,
      updatedAt: serverTimestamp()
    });

    return { success: true };
  } catch (error) {
    console.error('removeProductDiscount error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Toplu indirim uygula (ESKİ - Geriye dönük uyumluluk için)
 */
export const applyBulkDiscount = async (productIds, discountData) => {
  try {
    const batch = writeBatch(db);
    const results = [];

    for (const productId of productIds) {
      const productRef = doc(db, 'Products', productId);
      const snapshot = await getDoc(productRef);

      if (snapshot.exists()) {
        const product = snapshot.data();
        const originalPrice = product.originalPrice || product.price;
        let newPrice = originalPrice;

        switch (discountData.type) {
          case 'percentage':
            newPrice = originalPrice * (1 - discountData.value / 100);
            break;
          case 'fixed':
            newPrice = originalPrice - discountData.value;
            break;
        }

        newPrice = Math.max(0, newPrice);

        batch.update(productRef, {
          originalPrice: originalPrice,
          currentPrice: newPrice,
          price: newPrice,
          discountType: discountData.type,
          discountValue: discountData.value,
          discountStartDate: discountData.startDate || null,
          discountEndDate: discountData.endDate || null,
          discount: discountData.type === 'percentage' ? discountData.value :
            Math.round((1 - newPrice / originalPrice) * 100),
          updatedAt: serverTimestamp()
        });

        results.push({ productId, success: true });
      }
    }

    await batch.commit();
    return { success: true, results };
  } catch (error) {
    console.error('applyBulkDiscount error:', error);
    return { success: false, error: error.message };
  }
};

// ==================== YENİ KAMPANYA SİSTEMİ ====================

/**
 * Kampanya Türleri:
 * - general: Genel kampanya (tüm ürünlere veya ücretsiz kargo)
 * - product: Tek ürüne özel kampanya
 * - category: Kategoriye özel kampanya
 * - subcategory: Alt kategoriye özel kampanya
 * 
 * İndirim Türleri:
 * - discount: Yüzde indirim (ürünlere uygulanır)
 * - free_shipping: Ücretsiz kargo (sepet toplamına göre)
 */

export const addCampaign = async (campaignData) => {
  try {
    console.log('📢 Kampanya oluşturuluyor:', campaignData);

    // Validasyon
    if (!campaignData.title) {
      return { success: false, error: 'Kampanya başlığı gerekli' };
    }

    if (!campaignData.campaignType) {
      campaignData.campaignType = 'general';
    }

    // Tarih kontrolü ve düzeltme
    const now = new Date();
    const startDate = campaignData.startDate 
      ? new Date(campaignData.startDate) 
      : now;
    
    const endDate = campaignData.endDate 
      ? new Date(campaignData.endDate) 
      : null; // null = süresiz

    // İndirim kampanyası kontrolü
    if (campaignData.discountType === 'discount') {
      if (!campaignData.discountPercent || campaignData.discountPercent <= 0) {
        return { success: false, error: 'İndirim oranı gerekli' };
      }
      if (campaignData.discountPercent > 100) {
        return { success: false, error: 'İndirim %100\'den fazla olamaz' };
      }
    }

    // Ücretsiz kargo kontrolü
    if (campaignData.discountType === 'free_shipping') {
      if (!campaignData.freeShippingThreshold || campaignData.freeShippingThreshold <= 0) {
        return { success: false, error: 'Minimum tutar gerekli' };
      }
    }

    // Target kontrolü (product/category/subcategory için)
    if (['product', 'category', 'subcategory'].includes(campaignData.campaignType)) {
      if (!campaignData.targetId) {
        return { success: false, error: 'Hedef seçimi gerekli' };
      }
    }

    const campaign = {
      title: campaignData.title,
      description: campaignData.description || '',
      campaignType: campaignData.campaignType, // general/product/category/subcategory
      discountType: campaignData.discountType || 'discount', // discount/free_shipping
      
      // İndirim bilgileri
      discountPercent: campaignData.discountPercent || 0,
      
      // Ücretsiz kargo bilgileri
      freeShippingThreshold: campaignData.freeShippingThreshold || null,
      
      // Hedef bilgileri
      targetId: campaignData.targetId || null, // product ID, category veya subcategory
      targetName: campaignData.targetName || null, // Görsel amaçlı
      
      // ESKİ SİSTEMLE UYUMLULUK
      targetCategory: campaignData.targetCategory || campaignData.targetId || null,
      minPurchase: campaignData.minPurchase || 0,
      
      // Tarih
      startDate: startDate.toISOString(),
      endDate: endDate ? endDate.toISOString() : null,
      
      // Durum
      isActive: true,
      usageCount: 0,
      
      // Meta
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };

    const docRef = await addDoc(campaignsCollection, campaign);
    console.log('✅ Kampanya oluşturuldu:', docRef.id);

    // İndirim kampanyası ise hemen ürünlere uygula
    if (campaign.discountType === 'discount') {
      await applyDiscountToProducts(docRef.id, campaign);
    }

    return { 
      success: true, 
      id: docRef.id,
      campaignId: docRef.id,
      campaign: { id: docRef.id, ...campaign }
    };

  } catch (error) {
    console.error('❌ Kampanya oluşturma hatası:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Kampanyayı ürünlere uygula (OTOMATIK)
 */
const applyDiscountToProducts = async (campaignId, campaign) => {
  try {
    console.log('🔄 Kampanya ürünlere uygulanıyor:', campaignId);

    let targetProducts = [];

    // Hedef ürünleri belirle
    if (campaign.campaignType === 'product') {
      // Tek ürün
      const productDoc = await getDoc(doc(db, 'Products', campaign.targetId));
      if (productDoc.exists()) {
        targetProducts = [{ id: productDoc.id, ...productDoc.data() }];
      }
    } else if (campaign.campaignType === 'category') {
      // Kategori
      const q = query(productsCollection, where('category', '==', campaign.targetId));
      const snapshot = await getDocs(q);
      targetProducts = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } else if (campaign.campaignType === 'subcategory') {
      // Alt kategori
      const q = query(productsCollection, where('subcategory', '==', campaign.targetId));
      const snapshot = await getDocs(q);
      targetProducts = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } else {
      // Genel kampanya - tüm ürünler
      const snapshot = await getDocs(productsCollection);
      targetProducts = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    }

    console.log(`📦 ${targetProducts.length} ürüne indirim uygulanacak`);

    // Batch ile tüm ürünleri güncelle
    const batch = writeBatch(db);

    targetProducts.forEach(product => {
      const productRef = doc(db, 'Products', product.id);
      const originalPrice = product.originalPrice || product.price;
      const discountedPrice = originalPrice * (1 - campaign.discountPercent / 100);

      batch.update(productRef, {
        discount: campaign.discountPercent,
        discountType: 'percentage',
        currentPrice: parseFloat(discountedPrice.toFixed(2)),
        originalPrice: originalPrice,
        campaignId: campaignId,
        campaignTitle: campaign.title,
        discountStartDate: campaign.startDate,
        discountEndDate: campaign.endDate,
        updatedAt: serverTimestamp()
      });
    });

    await batch.commit();

    console.log(`✅ ${targetProducts.length} ürüne indirim uygulandı`);
    return { success: true, count: targetProducts.length };

  } catch (error) {
    console.error('❌ İndirim uygulama hatası:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Tüm kampanyaları getir
 */
// src/services/discountService.js - getAllCampaigns fonksiyonunu güncelle

/**
 * Tüm kampanyaları getir
 */
export const getAllCampaigns = async () => {
  try {
    const q = query(campaignsCollection, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);

    const campaigns = [];
    const now = new Date();

    querySnapshot.forEach((document) => {
      const data = document.data();
      
      // ✅ Aktif kampanyaları filtrele
      const isActive = data.isActive !== false;
      
      // ✅ Süresi dolmamış kampanyaları filtrele
      const endDate = data.endDate ? new Date(data.endDate) : null;
      const isNotExpired = !endDate || endDate > now;
      
      // ✅ Sadece aktif ve süresi dolmamış kampanyaları ekle
      if (isActive && isNotExpired) {
        campaigns.push({
          id: document.id,
          ...data,
          // Tarih dönüşümü
          startDate: data.startDate || null,
          endDate: data.endDate || null,
          createdAt: data.createdAt?.toDate() || null
        });
      }
    });

    console.log('✅ Aktif kampanyalar yüklendi:', campaigns.length);
    campaigns.forEach(c => {
      console.log(`  - ${c.title}:`);
      console.log(`    Type: ${c.campaignType}`);
      console.log(`    Discount: ${c.discountPercent}%`);
      console.log(`    Target: ${c.targetCategory || 'Genel'}`);
      console.log(`    Min: ${c.minPurchase || 0}₺`);
      console.log(`    End: ${c.endDate || 'Süresiz'}`);
    });
    
    return { success: true, campaigns };

  } catch (error) {
    console.error('❌ Kampanya yükleme hatası:', error);
    return { success: false, error: error.message, campaigns: [] };
  }
};

/**
 * Kampanya güncelle
 */
export const updateCampaign = async (campaignId, campaignData) => {
  try {
    console.log('🔄 Kampanya güncelleniyor:', campaignId);

    const campaignRef = doc(db, 'Campaigns', campaignId);
    const campaignDoc = await getDoc(campaignRef);

    if (!campaignDoc.exists()) {
      return { success: false, error: 'Kampanya bulunamadı' };
    }

    // Tarih kontrolü
    const startDate = campaignData.startDate 
      ? new Date(campaignData.startDate) 
      : campaignDoc.data().startDate ? new Date(campaignDoc.data().startDate) : new Date();
    
    const endDate = campaignData.endDate 
      ? new Date(campaignData.endDate) 
      : campaignDoc.data().endDate ? new Date(campaignDoc.data().endDate) : null;

    const updatedData = {
      title: campaignData.title || campaignDoc.data().title,
      description: campaignData.description || campaignDoc.data().description,
      discountPercent: campaignData.discountPercent !== undefined 
        ? campaignData.discountPercent 
        : campaignDoc.data().discountPercent,
      freeShippingThreshold: campaignData.freeShippingThreshold !== undefined
        ? campaignData.freeShippingThreshold
        : campaignDoc.data().freeShippingThreshold,
      minPurchase: campaignData.minPurchase !== undefined
        ? campaignData.minPurchase
        : campaignDoc.data().minPurchase,
      targetCategory: campaignData.targetCategory || campaignDoc.data().targetCategory,
      startDate: startDate.toISOString(),
      endDate: endDate ? endDate.toISOString() : null,
      isActive: campaignData.isActive !== undefined 
        ? campaignData.isActive 
        : campaignDoc.data().isActive,
      updatedAt: serverTimestamp()
    };

    await updateDoc(campaignRef, updatedData);

    // İndirim kampanyası ise ürünleri yeniden güncelle
    if (campaignDoc.data().discountType === 'discount') {
      await applyDiscountToProducts(campaignId, {
        ...campaignDoc.data(),
        ...updatedData
      });
    }

    console.log('✅ Kampanya güncellendi');
    return { success: true };

  } catch (error) {
    console.error('❌ Kampanya güncelleme hatası:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Kampanya sil
 */
export const deleteCampaign = async (campaignId) => {
  try {
    console.log('🗑️ Kampanya siliniyor:', campaignId);

    const campaignRef = doc(db, 'Campaigns', campaignId);
    const campaignDoc = await getDoc(campaignRef);

    if (!campaignDoc.exists()) {
      return { success: false, error: 'Kampanya bulunamadı' };
    }

    // Kampanya ürünlerinden indirimi kaldır
    await removeDiscountFromProducts(campaignId);

    // Kampanyayı sil
    await deleteDoc(campaignRef);

    console.log('✅ Kampanya silindi');
    return { success: true };

  } catch (error) {
    console.error('❌ Kampanya silme hatası:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Kampanya indirimini ürünlerden kaldır
 */
const removeDiscountFromProducts = async (campaignId) => {
  try {
    console.log('🔄 Kampanya indirimi kaldırılıyor:', campaignId);

    // Kampanyaya ait ürünleri bul
    const q = query(productsCollection, where('campaignId', '==', campaignId));
    const snapshot = await getDocs(q);

    if (snapshot.empty) {
      console.log('ℹ️ Kampanyaya ait ürün yok');
      return { success: true, count: 0 };
    }

    const batch = writeBatch(db);

    snapshot.docs.forEach(doc => {
      const productRef = doc.ref;
      const product = doc.data();

      batch.update(productRef, {
        discount: 0,
        discountType: 'none',
        currentPrice: product.originalPrice || product.price,
        campaignId: null,
        campaignTitle: null,
        discountStartDate: null,
        discountEndDate: null,
        updatedAt: serverTimestamp()
      });
    });

    await batch.commit();

    console.log(`✅ ${snapshot.size} üründen indirim kaldırıldı`);
    return { success: true, count: snapshot.size };

  } catch (error) {
    console.error('❌ İndirim kaldırma hatası:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Ücretsiz kargo kampanyasını al (MEVCUT - KORULDU)
 */
export const getFreeShippingCampaign = async () => {
  try {
    const q = query(campaignsCollection, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);

    const now = new Date();
    let freeShippingCampaign = null;

    querySnapshot.forEach((document) => {
      const campaign = { id: document.id, ...document.data() };

      // Aktif ücretsiz kargo kampanyasını bul
      if (
        campaign.discountType === 'free_shipping' &&
        campaign.isActive &&
        (!campaign.endDate || new Date(campaign.endDate) > now)
      ) {
        freeShippingCampaign = campaign;
      }
    });

    return { success: true, campaign: freeShippingCampaign };
  } catch (error) {
    console.error('Ücretsiz kargo kampanyası alınırken hata:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Kampanya türüne göre filtrele (MEVCUT - KORULDU)
 */
export const getCampaignsByType = async (campaignType) => {
  try {
    const q = query(campaignsCollection, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);

    const campaigns = [];
    querySnapshot.forEach((document) => {
      const campaign = { id: document.id, ...document.data() };
      if (campaign.campaignType === campaignType) {
        campaigns.push(campaign);
      }
    });

    return { success: true, campaigns };
  } catch (error) {
    console.error('Kampanyalar getirilirken hata:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Ürüne uygulanan kampanyayı getir
 */
export const getProductCampaign = async (productId) => {
  try {
    const productDoc = await getDoc(doc(db, 'Products', productId));
    
    if (!productDoc.exists() || !productDoc.data().campaignId) {
      return { success: true, campaign: null };
    }

    const campaignDoc = await getDoc(doc(db, 'Campaigns', productDoc.data().campaignId));
    
    if (!campaignDoc.exists()) {
      return { success: true, campaign: null };
    }

    return {
      success: true,
      campaign: {
        id: campaignDoc.id,
        ...campaignDoc.data()
      }
    };

  } catch (error) {
    console.error('❌ Kampanya getirme hatası:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Aktif kampanyaları kontrol et ve süresi dolmuşları pasifleştir (CRON JOB)
 */
export const checkExpiredCampaigns = async () => {
  try {
    console.log('⏰ Süresi dolan kampanyalar kontrol ediliyor...');

    const now = new Date();
    const snapshot = await getDocs(campaignsCollection);

    let expiredCount = 0;

    for (const doc of snapshot.docs) {
      const campaign = doc.data();
      
      // Süresiz kampanyaları atla
      if (!campaign.endDate) continue;

      const endDate = new Date(campaign.endDate);

      // Süresi dolmuşsa pasif yap ve indirimi kaldır
      if (endDate < now && campaign.isActive) {
        await updateDoc(doc.ref, {
          isActive: false,
          updatedAt: serverTimestamp()
        });

        if (campaign.discountType === 'discount') {
          await removeDiscountFromProducts(doc.id);
        }

        expiredCount++;
        console.log(`⏰ Kampanya süresi doldu: ${campaign.title}`);
      }
    }

    console.log(`✅ ${expiredCount} kampanya pasif hale getirildi`);
    return { success: true, expiredCount };

  } catch (error) {
    console.error('❌ Kampanya kontrol hatası:', error);
    return { success: false, error: error.message };
  }
};

// ==================== EXPORT ====================
export default {
  // ESKİ FONKSİYONLAR (Geriye dönük uyumluluk)
  applyProductDiscount,
  removeProductDiscount,
  applyBulkDiscount,
  
  // KAMPANYA YÖNETİMİ
  addCampaign,
  getAllCampaigns,
  updateCampaign,
  deleteCampaign,
  
  // YARDIMCI FONKSİYONLAR
  getFreeShippingCampaign,
  getCampaignsByType,
  getProductCampaign,
  checkExpiredCampaigns
};